import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { AiChatHistoryMessage, GenerateReportFromAiResponse } from '../types/ai-report';

export const generateReportFromAi = async (
  reportId: string,
  messages: AiChatHistoryMessage[]
): Promise<GenerateReportFromAiResponse> => {
  const endpoint = '/api/reports/ai/generate';
  return withApiErrorHandler(endpoint, ApiErrorCode.REPORT_AI_GENERATE_FAILED, () =>
    axiosInstance.post<ApiResponse<GenerateReportFromAiResponse>>(endpoint, { reportId, messages })
  );
};
